@if (menuItem(); as menuItem) {
  @if (isLoading()) {
    <div class="menu-item menu-item--loading">
      <ftr-loader [isLoading]="true" [iconOnly]="true" [color]="COLOR.Primary50" [size]="LOADER_SIZE.Small" />
    </div>
  } @else {
    @if (isLink(menuItem)) {
      <a
        class="menu-item menu-item--interactive"
        [routerLink]="menuItem.path"
        [target]="menuItem.openInNewWindow ? '_blank' : undefined"
        [rel]="menuItem.openInNewWindow ? 'noopener noreferrer' : null"
        [attr.data-track]="trackClicks() ? '' : null"
        [attr.data-testid]="menuItem.testId"
      >
        <ng-container *ngTemplateOutlet="content" />
      </a>
    } @else if (isButton(menuItem)) {
      <button
        class="menu-item menu-item--interactive"
        [class]="{
          'menu-item--destructive': menuItem.isDestructive,
        }"
        (click)="handleButtonClicked()"
        [attr.data-track]="trackClicks() ? '' : null"
        [attr.data-testid]="menuItem.testId"
      >
        <ng-container *ngTemplateOutlet="content" />
      </button>
    } @else {
      <div class="menu-item menu-item--static" [attr.data-testid]="menuItem.testId">
        <ng-container *ngTemplateOutlet="content" />
      </div>
    }
  }

  <ng-template #content>
    <div class="menu-item__content">
      @if (menuItem.icon) {
        <svg
          [ftrIcon]="menuItem.icon"
          [iconSize]="16"
          [style.color]="menuItem.iconColor ?? defaultIconColor()"
          aria-hidden="true"
        ></svg>
      }
      <span class="menu-item__label" [style.color]="menuItem.labelColor">{{ menuItem.label }}</span>

      @if (isSelectableButton(menuItem)) {
        <div class="menu-item__right-section">
          <svg
            ftrIcon="Checkmark"
            [iconSize]="16"
            iconColor="Grey40"
            [style.visibility]="menuItem.isSelected ? 'visible' : 'hidden'"
          ></svg>
        </div>
      }

      @if (shouldShowOpenInNewWindowIcon()) {
        <div class="menu-item__right-section">
          <svg ftrIcon="OpenInNew" [iconSize]="16" iconColor="Grey40" aria-hidden="true"></svg>
        </div>
      }
    </div>

    @if (menuItem.secondaryText) {
      <div class="menu-item__secondary-content">
        <span class="menu-item__secondary-text">
          {{ menuItem.secondaryText }}
        </span>
      </div>
    }
  </ng-template>
}
